var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{staticClass:"default-font",style:({ '--brand-color': _vm.app.brandInfo.color || '#503df6' })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }